export default __webpack_public_path__ + "static/media/ovary_plot.e092abe8.png";